import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../../store/auth.store";
import { PartnerApi } from "../../../api/partner.api";
import { useCompanyPersons } from "../../../hook/partner/company.partner.hook";
import { useCompanyStore } from "../../../store/company.store";
import { useVendorsStore } from "../../../store/vendors.store";
import { useVendors } from "../../../hook/partner/vendors.partner.hook";
import { useTranslation } from "../../../hooks/useTranslation";

export default function DealNewForm({ handleClose, items = null }) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [addPerson, setAddPerson] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [searchCompany, setSearchCompany] = useState(null);
  const [companies, setCompanies] = useState(null);
  const navigate = useNavigate();

  const companyPersonsMutation = useCompanyPersons();
  const persons = useCompanyStore((state) => state.persons);

  const vendorsMutation = useVendors();
  const vendors = useVendorsStore((state) => state.vendors);

  const token = useAuthStore((state) => state.token);

  const createDeal = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    setError(null);
    const result = PartnerApi.dealAdd({
      token,
      data: {
        project_name: formData.get("project_name"),
        specification: formData.get("specification"),
        description: formData.get("description"),
        customer_company_id: formData.get("customer_company_id"),
        customer_person_id: formData.get("customer_person_id"),
        first_name: formData.get("first_name"),
        last_name: formData.get("last_name"),
        email: formData.get("email"),
        phone: formData.get("phone"),
        close_date: formData.get("close_date"),
        vendor_id: formData.get("vendor_id"),
      },
    });
    result
      .then((result) => {
        if ("error" in result) {
          setError(result.error);
          return;
        }

        if ("deal_id" in result) {
          handleClose();
          return navigate("/deal/" + result.deal_id);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return false;
  };

  useEffect(() => {
    if (token && searchCompany) {
      setError(null);
      PartnerApi.companySearch({ token, search: searchCompany }).then(
        (result) => {
          if ("error" in result) {
            setError(result.error);
            setCompanies([]);
            return;
          }

          setError(null);
          setCompanies(result);
        }
      );
    }
  }, [token, searchCompany]);

  useEffect(() => {
    if (selectedCompany) {
      companyPersonsMutation.mutate({
        company_id: selectedCompany,
        token: token,
      });
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (token) {
      vendorsMutation.mutate({
        token: token,
      });
    }
  }, [token]);

  return (
    <form onSubmit={(e) => createDeal(e)}>
      {error && <p className="alert alert-danger">{error}</p>}

      <div className="row">
        <div className="col-md-4">
          <div className="mb-2">
            <label className="required form-label">{t("loans.customer")}</label>
            <input
              type="text"
              defaultValue={searchCompany}
              required={true}
              onChange={(e) => setSearchCompany(e.target.value)}
              className="form-control form-control-solid"
              placeholder={t("deals.enterCompanyId")}
            />

            <input
              type="hidden"
              name="customer_company_id"
              value={selectedCompany}
            />
          </div>

          <div className="overflow-auto mb-10" style={{ maxHeight: "170px" }}>
            <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
              {companies?.map((company, company_key) => (
                <div className="menu-item" key={company_key}>
                  <div
                    onClick={() => setSelectedCompany(company.company_id)}
                    className={
                      "cursor-pointer menu-link " +
                      (selectedCompany == company.company_id ? "active" : "")
                    }
                  >
                    {selectedCompany == company.company_id && (
                      <span className="menu-icon" data-kt-element="icon">
                        <i className="ki-duotone ki-check fs-2">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                    )}

                    <span className="menu-title">
                      {company.name}
                      <br />
                      {t("company.companyId")}: {company.ic}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {selectedCompany && (
              <div className="mb-10">
                <label className="required form-label">{t("deals.customerContact")}</label>
                {persons && persons.length > 0 && (
                    <select name="customer_person_id"
                            className="mb-10 form-control form-control-solid"
                            defaultValue={0}
                    required={addPerson==false}>
                      <option value="">{t("deals.selectCustomerPerson")}</option>
                      {persons.map((person, key) => (
                          <option key={key} value={person.person_id}>{person.first_name} {person.last_name}</option>
                      ))}
                    </select>
                )}

                {addPerson == false ? (
                    <button type="button" className="btn btn-light" onClick={()=>setAddPerson(true)}>{t("users.addPerson")}</button>
                ) : (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-row mb-5">
                            <label className="form-label fs-5 fw-semibold mb-3">
                              {t("users.firstName")}:
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                name="first_name"
                                required={true}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-row mb-5">
                            <label className="form-label fs-5 fw-semibold mb-3">
                              {t("users.lastName")}:
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                name="last_name"
                                required={true}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-row mb-5">
                            <label className="form-label fs-5 fw-semibold mb-3">
                              {t("deals.phone")}:
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                name="phone"
                                required={true}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-row mb-5">
                            <label className="form-label fs-5 fw-semibold mb-3">
                              {t("users.email")}:
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                name="email"
                                required={true}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                )}

              </div>
          )}
        </div>
        <div className="col-md-8">
        <div className="mb-10">
            <label className="required form-label">{t("deals.projectName")}</label>
            <input
              type="text"
              name="project_name"
              required={true}
              className="form-control form-control-solid"
            />
          </div>

          <div className="mb-10">
            <label className="required form-label">{t("deals.expectedCloseDate")}</label>
            <input
              type="date"
              name="close_date"
              required={true}
              className="form-control form-control-solid"
            />
          </div>

          <input type="hidden" name="vendor_id" value="34" />
          {/*
                    Pouze Logmanager - 34
                    <div className="mb-10">
                        <label className="required form-label">Kterého výrobce chcete pro tento deal
                            registrovat?</label>

                        <select
                            name="vendor_id"
                            required={true}
                            className="form-control form-control-solid">
                            {vendors?.map((vendor, key) => (
                                <option key={key} value={vendor.vendor_id}>
                                    {vendor.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    */}

          <div className="mb-10">
            <label className="required form-label">{t("deals.deviceSpec")}</label>
            <textarea
              name="specification"
              required={true}
              className="form-control form-control-solid"
            />
          </div>

          <div className="mb-10">
            <label className="form-label">{t("deals.additionalInfo")}</label>
            <textarea
              name="description"
              className="form-control form-control-solid"
            />
          </div>
        </div>
      </div>

      <div className="text-center">
        <button type="submit" className="btn btn-primary">
          {t("common.create")}
        </button>
      </div>
    </form>
  );
}
